import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-300 py-8 mt-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-white font-bold mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white">Today's Events</Link></li>
              <li><Link to="/calendar" className="hover:text-white">Calendar</Link></li>
              <li><Link to="/submit" className="hover:text-white">Submit Event</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-bold mb-3">About</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><button onClick={() => {}} className="hover:text-white text-left">Privacy Policy</button></li>
              <li><button onClick={() => {}} className="hover:text-white text-left">Terms of Service</button></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-bold mb-3">Contact</h3>
            <p className="text-sm">
              For questions or suggestions,<br />
              contact us anytime.
            </p>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-6 text-center text-sm">
          <p>&copy; 2025 AlpharettaKidsEvents. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
